import { useQuery } from "@tanstack/react-query";

import ViewsService from "@/services/ViewsService";

import { projectKeys } from "@/constants/CQueryKeys";

import { TProject } from "@/types";

const EMPTY: TProject[] = [];

/**
 * A view's projects, by name. One query key for the home breadcrumb,
 * the sidebar and the active-project lookup, so they share the cache and
 * the invalidations of useProjectActions.
 */
export const useProjectsOfView = (viewId?: number) => {
	const query = useQuery({
		queryKey: projectKeys.ofView(viewId ?? 0),
		queryFn: () =>
			ViewsService.getViewProjects(viewId!).then((resp: TProject[]) =>
				[...resp].sort((a, b) => a.name.localeCompare(b.name))
			),
		enabled: !!viewId,
		// Same reason as useViews; useProjectActions invalidates the key.
		staleTime: 5 * 60 * 1000,
	});
	return { projects: query.data ?? EMPTY, isLoading: query.isLoading };
};
